import { ReactElement, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { LegacyPage } from '@legacy/components/layout/LegacyPage';
import { useVerifyDesignSevenPage } from '@legacy/apis/pagesAPI/designSevenAPI';
import { LoadingSpinner } from '@legacy/components/ui-components/LoadingSpinner/LoadingSpinner';
import { useTranslation } from 'react-i18next';
import { translationAnyText } from '@legacy/utils/translation';
import { usePageStore } from '@legacy/stores/PageStore/pageStore.zustand';

interface PageRouteProps {
  pageId: string;
  pageIdentifier: string;
  pageTitle: string;
  children: ReactElement;
  fallbackUrl?: string;
}

export const PageRoute = ({
  children,
  pageIdentifier,
  pageId,
  pageTitle,
  fallbackUrl,
}: PageRouteProps) => {
  const { isDesignSeven, isLoading } = useVerifyDesignSevenPage(pageIdentifier);
  const { pathname, search } = useLocation();
  const { t } = useTranslation('screenHeaderTitle');
  const navigate = useNavigate();
  const setCurrentPage = usePageStore((state) => state.setCurrentPage);
  const setLastVisitedPage = usePageStore((state) => state.setLastVisitedPage);

  useEffect(() => {
    setCurrentPage({
      pageIdentifier,
      pageId,
      pageTitle: translationAnyText(t, pageTitle),
    });
    setLastVisitedPage(pathname + search, pageIdentifier);
  });

  // Fallback to specific page if not design seven
  useEffect(() => {
    if (!isLoading && !isDesignSeven && fallbackUrl) {
      navigate(fallbackUrl);
    }
  }, [isLoading, isDesignSeven, navigate, fallbackUrl]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return isDesignSeven ? (
    children
  ) : (
    <LegacyPage data-automation-id="FallBackLegacyPage" />
  );
};
